// extracted by mini-css-extract-plugin
module.exports = {"container":"OfsLimit_container__2vTGu"};